import { render, staticRenderFns } from "./ScrolltopPage.vue?vue&type=template&id=0824c00d&"
import script from "./ScrolltopPage.vue?vue&type=script&lang=ts&"
export * from "./ScrolltopPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports